import moment from 'moment';
import c from '@/components/Core/constants.js';
const WeekDayRender = (year) => {
	let currentYear = moment().year();
	let currentDayIndex = null;
	let currentDayRow = -1;
	let currentDayColumn = -1;

	if (currentYear == year) {
		let todaysDay = parseInt(moment().format('DD'), 10);
		let firstDayOfCurrentMonth = parseInt(moment(moment().format('YYYY-MM') + '-01').day(), 10);

		currentDayIndex = todaysDay + firstDayOfCurrentMonth - 1;
		if (currentDayIndex > 35) {
			// Prepended Date
			currentDayIndex = currentDayIndex - 35;
		}

		currentDayRow = parseInt(currentDayIndex / 7, 0);
		currentDayColumn = parseInt(currentDayIndex % 7, 0);
	}

	const header = `
  <div class="fc-ob-week-day-render-container">
    <table class="fc-ob-week-day-render">
      <tr>
  `;

	let tds = `<td style="background-image:url('${c.CDNIMAGESBASEURL}/ess/ESSApp/static/Images/search_background.png')"><div class="fc-ob-cell"></div></td>`;

	let weekDays = [ 'S', 'M', 'T', 'W', 'T', 'F', 'S' ];

	for (var i = 0; i < 5; i++) {
		for (var j = 0; j < 7; j++) {
			if (i == currentDayRow && j == currentDayColumn) {
				// Today
				tds += `<td><div class="fc-ob-cell current-date"><span style="margin-left: -8px;margin-top: -4px;">${weekDays[
					j
				]}</span></div></td>`;
			} else {
				tds += `<td><div class="fc-ob-cell"><span>${weekDays[j]}</span></div></td>`;
			}
		}
	}

	const footer = `
      </tr>
    </table>
  </div>
  `;

	return header + tds + footer;
};

export default WeekDayRender;



// WEBPACK FOOTER //
// ./src/components/ESSProfile/Timesheets/Calender/CustomViews/Yearly/WeekDayRender/WeekDayRender.js